import BankingSwitchFAQ from '../../../bankingSwitch/components/BankingSwitchFAQ';

export default function BankingSwitchFAQScreen() {
    return <BankingSwitchFAQ />;
}
